// removed by extract-text-webpack-plugin
module.exports = {"photo":"responsive__photo___2JlB8","wrapper":"responsive__wrapper___PuvlF","image":"responsive__image___3NYjm","fadein":"responsive__fadein___OHGTo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/images/responsive.scss
// module id = 386
// module chunks = 0